<div id="opciones" class="form-width-size first-container-options-xs d-flex justify-content-center align-items-center flex-column position-relative align-self-center" action="">

  <div class="container-logo-steps-xs d-flex d-md-none align-self-end">
    <img class="logo-img-size logo__astronaut" [src]="url_img.logo_blue" alt="">
  </div>
  <div class="container-return-style m-b-40 align-self-start">
    <img class="img-return-blue" [src]="url_img.return_blue" alt="" (click)="previous()">
  </div>
 
  <div class="">
    <div class="d-block m-b-40 w-100">
      <p class=" heading-b-m-24 text-start line-height-20 text-start">
        ¿Tienes un proveedor <br class="d-block d-sm-none"> de recursos?
      </p>
      <p class="paragraph-b-r-16 line-height-1-2">
        Es aquella persona que, sin ser titular de la cuenta Bursanet, aportará regularmente recursos sin obtener beneficios económicos derivados de esa operación.
      </p>
    </div>

    <div class=" m-b-26">
      <div class="card-select-option d-flex flex-column justify-content-center align-items-start" (click) = "assistedOpening()">
        <p class="paragraph-b-r-16 mb-0">
          <span class="paragraph-b-b-16">Sí,</span> tengo un proveedor <br class="d-block d-sm-none"> de recursos
        </p>
        <img class="right-arrow-style " [src]="url_img.right_blue" alt="">

      </div>
    </div>

    <div class="">
      <div class="card-select-option d-flex flex-column justify-content-center align-items-start" (click) = "autonomousOpening()">
        <p class="paragraph-b-r-16 mb-0">
          <span class="paragraph-b-b-16"> No,</span> yo seré el único aportador
        </p>
        <img class="right-arrow-style " [src]="url_img.right_blue" alt="">

      </div>
    </div>
  </div>


</div>
